// Loading.js
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LeftSide } from '../../components/LeftSide/LeftSide';
import { Navi } from '../../components/Navi/Navi';
import { RightBar } from '../../components/RightBar/RightBar';
import AuthService from '../../services/authService';
import { Modal, Button } from 'react-bootstrap';

const KeyWordVer2 = ({ title = '키워드 추출 순위 조회 Ver2' }) => {
    const [productId, setProductId] = useState('');
    const [productName, setProductName] = useState('');
    const [excludeKeywords, setExcludeKeywords] = useState('');
    const [includeKeyword, setIncludeKeyword] = useState('');
    const [rankings, setRankings] = useState([]);
    //const [keywordList, setKeywordList] = useState([]);
    //const [productInfo, setProductInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searched, setSearched] = useState(false);

    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [historyDataGubun, setHistoryDataGubun] = useState('keywordver2');

    const [historyData, setHistoryData] = useState([]);
    const [historyLoaded, setHistoryLoaded] = useState(false);
    const PAGE_SIZE = 10;
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const productIdRef = useRef(null);
    const productNameRef = useRef(null);
    const excludeKeywordsRef = useRef(null);
    const includeKeywordRef = useRef(null);

    const stripHtml = html => html.replace(/<[^>]*>/g, '');
    const formatPrice = price => Number(price).toLocaleString();
    const formatCategory = product => {
        return [product.category1, product.category2, product.category3, product.category4]
            .filter(Boolean)
            .join(' > ');
    };

    const fetchRankings = async () => {
        if (!productId.trim()) {
            alert('MID를 입력하세요.');
            productIdRef.current.focus();
            return;
        }
        if (!productName.trim()) {
            alert('상품명을 입력하세요.');
            productNameRef.current.focus();
            return;
        }
        if (!includeKeyword.trim()) {
            alert('포함 키워드를 입력하세요.');
            includeKeywordRef.current.focus();
            return;
        }

        setLoading(true);
        setError(null);
        //setRankings(sampleRankings);
        //setKeywordList([]);
        //setProductInfo(null);
        setSearched(true);
        try {
            const response = await AuthService.authAxios.get(`/productV2`, {
                params: {
                    productId,
                    keyword: includeKeyword,
                    productName,
                    excludeKeywords: excludeKeywords,
                },
            });

            if (!response.data.success) {
                setError('상품 정보가 없습니다.');
                return;
            }

            //setKeywordList(response.data.product.keywordList);

            // 순위 필터링 제거하고 모든 키워드 표시
            const allRankings = response.data.rankings.map(ranking => ({
                ...ranking,
                monthlySearch: Math.floor(Math.random() * 10000) + 1000, // 임시로 랜덤 데이터 추가
            }));

            setRankings(allRankings);

            // setProductInfo({
            //     image: response.data.product.image,
            //     title: stripHtml(response.data.product.title),
            //     price: formatPrice(response.data.product.lprice),
            //     link: response.data.product.link,
            //     mallName: response.data.product.mallName,
            //     category: formatCategory(response.data.product),
            // });
        } catch (err) {
            console.error(err);
            setError('상품 정보가 없습니다.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = e => {
        e.preventDefault();
        fetchRankings();
    };

    const handleReset = () => {
        setError(null);
        setProductId('');
        setProductName('');
        setExcludeKeywords('');
        setIncludeKeyword('');
        setRankings([]);
        //setKeywordList([]);
        //setProductInfo(null);
        setSearched(false);
        if (productIdRef.current) productIdRef.current.focus();
    };

    const handleDelete = async id => {
        if (!window.confirm('정말 삭제하시겠습니까?')) return;
        try {
            await AuthService.authAxios.post('/log/delete', { id }); // 삭제용 API
            setHistoryData(prev => prev.filter(item => item.id !== id));
            //fetchHistory(); // 다시 불러오기
        } catch (err) {
            console.error('삭제 실패:', err);
        }
    };

    const handleApplyInput = inputString => {
        const values = Object.fromEntries(inputString.split('|').map(pair => pair.split('=')));
        if (historyDataGubun === 'keywordver2') {
            setProductId(values.productId || '');
            setProductName(values.productName || '');
            setExcludeKeywords(values.excludeKeywords || '');
            setIncludeKeyword(values.keyword || '');
        } else {
            setProductName(values.product_name || '');
            setProductId(values.syncNvMid || '');
        }
        setShowHistoryModal(false); // react-bootstrap 모달 닫기
    };

    const fetchHistory = async (nextOffset = 0, append = false, gubun = 'keywordver2') => {
        setHistoryDataGubun(gubun);

        try {
            const res = await AuthService.authAxios.get('/log/history', {
                params: {
                    gubun: gubun,
                    offset: nextOffset,
                },
            });

            if (res.data.success) {
                const newData = res.data.data;
                if (!append) {
                    setHasMore(true); // ✅ 새로 로딩할 땐 초기화
                }
                if (newData.length < PAGE_SIZE) setHasMore(false);

                if (append) {
                    setHistoryData(prev => [...prev, ...newData]);
                    setOffset(prev => prev + PAGE_SIZE);
                } else {
                    setHistoryData(newData);
                    setOffset(PAGE_SIZE);
                }
            }
        } catch (err) {
            console.error('조회 기록 불러오기 실패:', err);
        } finally {
            setHistoryLoaded(true);
        }
    };
    return (
        <>
            {/* <!-- Begin page --> */}
            <div id="wrapper">
                <Navi title={title} />

                <LeftSide />

                <div className="content-page">
                    <div className="content">
                        {/* <!-- Start Content--> */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <blockquote className="card-bodyquote">
                                                <p>정보를 입력 후 조회 버튼을 클릭하세요.</p>
                                            </blockquote>
                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3">
                                                    <label
                                                        for="example-input-small"
                                                        className="form-label"
                                                    >
                                                        단일 MID
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="MID 입력"
                                                        value={productId}
                                                        onChange={e => setProductId(e.target.value)}
                                                        ref={productIdRef}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label
                                                        for="example-input-normal"
                                                        className="form-label"
                                                    >
                                                        상품명
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={productName}
                                                        onChange={e =>
                                                            setProductName(e.target.value)
                                                        }
                                                        className="form-control form-control-sm"
                                                        placeholder="상품명 입력"
                                                        ref={productNameRef}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label
                                                        for="example-input-normal"
                                                        className="form-label"
                                                    >
                                                        포함 키워드(쉼표로 구분, 상품명에 있는 단어)
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={includeKeyword}
                                                        onChange={e =>
                                                            setIncludeKeyword(e.target.value)
                                                        }
                                                        className="form-control form-control-sm"
                                                        placeholder="포함 키워드 입력"
                                                        ref={includeKeywordRef}
                                                        required
                                                    />
                                                    <span className="help-block">
                                                        <small>예) 포함 키워드 : '한우'</small>
                                                    </span>
                                                </div>

                                                <div className="mb-3">
                                                    <label
                                                        for="example-input-normal"
                                                        className="form-label"
                                                    >
                                                        제외 키워드(쉼표로 구분)
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={excludeKeywords}
                                                        onChange={e =>
                                                            setExcludeKeywords(e.target.value)
                                                        }
                                                        className="form-control form-control-sm"
                                                        placeholder="쉼표로 구분"
                                                        ref={excludeKeywordsRef}
                                                    />
                                                    <span className="help-block">
                                                        <small>
                                                            예) 제외키워드 : '1.8kg', '상견례',
                                                            '최고급형'
                                                        </small>
                                                    </span>
                                                </div>

                                                <div className="button-list">
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-primary waves-effect waves-light"
                                                        onClick={() => {
                                                            setShowHistoryModal(true);
                                                            fetchHistory(0, false, 'keywordver2');
                                                        }}
                                                    >
                                                        <i className="mdi mdi-history me-1"></i>
                                                        조회 기록
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-primary waves-effect waves-light"
                                                        onClick={() => {
                                                            setShowHistoryModal(true);
                                                            fetchHistory(0, false, 'findmid');
                                                        }}
                                                    >
                                                        <i className="mdi mdi-history me-1"></i>
                                                        MID 기록
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary waves-effect waves-light"
                                                        onClick={handleReset}
                                                    >
                                                        초기화
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary waves-effect waves-light float-end"
                                                    >
                                                        {loading && (
                                                            <span
                                                                className="spinner-border spinner-border-sm me-1"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        )}
                                                        조회
                                                    </button>
                                                </div>
                                                {error && (
                                                    <div
                                                        className="alert alert-danger bg-danger text-white border-0 mt-3 mb-0"
                                                        role="alert"
                                                    >
                                                        {error}
                                                    </div>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                {rankings.length > 0 && (
                                    <div className="col-xl-4">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" className="text-center">
                                                                키워드
                                                            </th>
                                                            <th scope="col" className="text-center">
                                                                순위
                                                            </th>
                                                            <th scope="col" className="text-center">
                                                                💻검색량
                                                            </th>
                                                            <th scope="col" className="text-center">
                                                                📱검색량
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rankings.map((item, index) => (
                                                            <tr key={index}>
                                                                <th scope="row">{item.keyword}</th>
                                                                <td className="text-center">
                                                                    {item.rank === 0
                                                                        ? '확인 불가'
                                                                        : item.rank}
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.searchVolume?.pc
                                                                        ? item.searchVolume.pc.toLocaleString()
                                                                        : '-'}
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.searchVolume?.mobile
                                                                        ? item.searchVolume.mobile.toLocaleString()
                                                                        : '-'}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* <!-- end col --> */}
                            </div>
                            {/* <!-- end row --> */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- content --> */}
                </div>
            </div>

            <RightBar />

            <div className="rightbar-overlay"></div>

            <Modal
                show={showHistoryModal}
                onHide={() => setShowHistoryModal(false)}
                size="lg"
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title>조회 기록</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!historyLoaded ? null : historyData.length === 0 ? (
                        <p>조회 기록이 없습니다.</p>
                    ) : (
                        <ul className="list-group">
                            {historyData.map((item, index) => (
                                <li key={index} className="list-group-item">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div>
                                            <div className="mb-1">
                                                {(() => {
                                                    const parts = {};
                                                    item.input.split('|').forEach(pair => {
                                                        const [key, value] = pair.split('=');
                                                        parts[key] = value;
                                                    });
                                                    if (historyDataGubun === 'keywordver2') {
                                                        return (
                                                            <>
                                                                <div className="mb-1">
                                                                    MID: {parts.productId || '-'}
                                                                    <br />
                                                                    상품명:{' '}
                                                                    {parts.productName || '-'}
                                                                    <br />
                                                                    포함키워드:{' '}
                                                                    {parts.keyword || '-'}
                                                                    <br />
                                                                    제외키워드:{' '}
                                                                    {parts.excludeKeywords || '-'}
                                                                    <br />
                                                                </div>
                                                                <small className="text-muted d-block">
                                                                    {item.updated_at ||
                                                                        item.searched_at}
                                                                </small>
                                                            </>
                                                        );
                                                    } else {
                                                        return (
                                                            <>
                                                                <div className="mb-1">
                                                                    스토어명:{' '}
                                                                    {parts.channel_name || '-'}
                                                                    <br />
                                                                    상품 URL: {parts.url || '-'}
                                                                    <br />
                                                                    상품명:{' '}
                                                                    {parts.product_name || '-'}
                                                                    <br />
                                                                    단일 MID:{' '}
                                                                    {parts.syncNvMid || '-'} / 원부
                                                                    MID: {parts.parentId || '-'}
                                                                    <br />
                                                                </div>
                                                                <small className="text-muted d-block">
                                                                    {item.updated_at ||
                                                                        item.searched_at}
                                                                </small>
                                                            </>
                                                        );
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                        <div className="ms-2 d-flex flex-row align-items-center ">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-1"
                                                style={{ whiteSpace: 'nowrap' }}
                                                onClick={() => {
                                                    handleApplyInput(item.input);
                                                    setShowHistoryModal(false);
                                                }}
                                            >
                                                {historyDataGubun === 'keywordver2'
                                                    ? '적용'
                                                    : 'MID 적용'}
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                style={{ whiteSpace: 'nowrap' }}
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                삭제
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                    {hasMore && historyData.length > 0 && (
                        <div className="text-center mt-3">
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => fetchHistory(offset, true)}
                            >
                                더보기
                            </button>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={() => setShowHistoryModal(false)}>
                        닫기
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* 조회 기록 모달 */}
            <div
                id="standard-modal"
                className="modal fade"
                tabindex="-1"
                role="dialog"
                aria-labelledby="standard-modalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="standard-modalLabel">
                                조회 기록
                            </h4>
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {!historyLoaded ? null : historyData.length === 0 ? (
                                <p>조회 기록이 없습니다.</p>
                            ) : (
                                <ul className="list-group">
                                    {historyData.map((item, index) => (
                                        <li key={index} className="list-group-item">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <div className="mb-1">
                                                        {(() => {
                                                            const parts = {};
                                                            item.input.split('|').forEach(pair => {
                                                                const [key, value] =
                                                                    pair.split('=');
                                                                parts[key] = value;
                                                            });
                                                            return (
                                                                <>
                                                                    <div className="mb-1">
                                                                        MID:{' '}
                                                                        {parts.productId || '-'}
                                                                        <br />
                                                                        상품명:{' '}
                                                                        {parts.productName || '-'}
                                                                        <br />
                                                                        포함키워드:{' '}
                                                                        {parts.keyword || '-'}
                                                                        <br />
                                                                        제외키워드:{' '}
                                                                        {parts.excludeKeywords ||
                                                                            '-'}
                                                                        <br />
                                                                    </div>
                                                                    <small className="text-muted d-block">
                                                                        {item.updated_at ||
                                                                            item.searched_at}
                                                                    </small>
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="ms-2 d-flex flex-row align-items-center">
                                                    <button
                                                        className="btn btn-sm btn-outline-primary me-1"
                                                        onClick={() => handleApplyInput(item.input)}
                                                    >
                                                        적용
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => handleDelete(item.id)}
                                                    >
                                                        삭제
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {hasMore && historyData.length > 0 && (
                                <div className="text-center mt-3">
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => fetchHistory(offset, true)}
                                    >
                                        더보기
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { KeyWordVer2 };
